export const UniversityEnum = {
    KAZAKH_NATIONAL_WOMEN_PEDAGOGICAL_UNIVERSITY: {id: 25, name: "Казахский национальный женский педагогический университет"},

    KORKYT_ATA_KYZYLORDA_UNIVERSITY: {id: 34, name: "Кызылординский университет имени Коркыт Ата"},
    BUKETOVA_KARAGANDA: {id: 31, name: "НАО \"Карагандинский национальный исследовательский университет имени академика Е.А.Букетова\""},
    NUR_MUBARAK: {id: 503, name: "Египетский университет исламской культуры «Нур-Мубарак»"},
}
